module.exports = __webpack_public_path__ + "static/media/bcom-finance_LR.0e2d747c.jpg";